import React, { useEffect, useState } from "react";
import { BASE_URL_PREBID } from "../../config/axios";
import { formatRoundoff } from "../custom";
import { DocumentIcon } from "../AllSvg";
import { formattedDateLong } from "../Date";
import axios from "axios";


const TransactionHistory = () => {

    const [statsduration, setStatsDuration] = useState("thismonth");

    const [transactionData, setTransactionData] = useState([]);

    useEffect(() => {
        const gettransactiondata = async () => {
            try {
                const res = await axios.get(`${BASE_URL_PREBID}/project/payment-receipts/total/`);
                setTransactionData(res.data);

            } catch (err) {
                // alert(err.message);
            }
        };
        gettransactiondata();
    }, []);

    return (
        <div className="invoice-cont height50vh   cont-col cards-shadow2 bgwhite" style={{ padding: "10px 0" }}>
            <div className="justify-between cont-row align-cen bgwhite mary-10 mary10">
                <div>
                    <h1 className="repo-heading font-size-heading font-weight500card-heading font-sizeheading " style={{ marginBottom: "0", paddingLeft: "20px" }}>Transaction History</h1>
                </div>
                {/* <div className="dashboard-priorities-select" >
                    <select
                        value={statsduration}
                        onChange={(e) => setStatsDuration(e.target.value)}
                        className="dashboard-sectiona-selection"
                    >
                        <option value="thismonth">This Month</option>
                        <option value="thisweek">This Week</option>
                        <option value="today">Today</option>
                        <option value="thisyear">This Year</option>
                        <option value="total">Overall</option>
                    </select>
                    <div className="dashboard-priorities-select-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                        </svg>
                    </div>
                </div> */}
            </div>

            <div className="global-table-cont scroll-container-table" style={{ minHeight: "45vh" }}>
                <table className="custom-table">
                    <thead>
                        <tr className="custom-table-head-trr-new global-table-tr">
                            <th className="align-center font-size-text font-weight400" >Sr no.</th>
                            <th className="align-left font-size-text font-weight400">Payment ID</th>
                            <th className="align-left font-size-text font-weight400">Invoice No</th>
                            <th className="align-left font-size-text font-weight400">Date</th>
                            <th className="align-right font-size-text font-weight400">Amount</th>
                            <th className="align-center font-size-text font-weight400">Status</th>
                            <th className="align-center font-size-text font-weight400">File</th>
                            <th className="align-center font-size-text font-weight400">Payment Method</th>
                            <th className="align-center font-size-text font-weight400">Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactionData.map((items, index) => {

                            return (
                                <React.Fragment key={index}>
                                    <tr className="tr-border-bottom">
                                        <td colSpan="8"></td>
                                    </tr>
                                    <tr className="custom-table-head-td global-table-td">
                                        <td className="align-center font-size-text font-weight400">{index + 1}</td>
                                        <td className="lign-center font-size-text font-weight400" title={`Full Name - ${items.payment_id}`}>
                                            {items.payment_id.length > 20
                                                ? items.payment_id.slice(0, 20) + "..."
                                                : items.payment_id}
                                        </td>
                                        <td className="align-left font-size-text font-weight400">{items.invoice_details?.length > 0 ?
                                            <ul>
                                                {items.invoice_details.map((inv, index) => (
                                                    <li>
                                                        {inv.invoice_number}
                                                    </li>)
                                                )}
                                            </ul>
                                            : 'No Attached'}</td>
                                        <td className="align-left font-size-text font-weight400" style={{ width: "10vw" }}>{formattedDateLong(items.payment_date)}</td>
                                        <td className="align-right font-size-text font-weight400">{formatRoundoff(items.amount)}</td>
                                        <td className="align-center font-size-text font-weight400">{items.payment_method}</td>
                                        <td className="align-center font-size-text font-weight400">{items.status}</td>
                                        <td className="align-center font-size-text font-weight400">{items.uploaded_file ?
                                            <a href={items.uploaded_file} target="_blank" rel="noreferrer">
                                                <DocumentIcon />
                                            </a>
                                            : "No File Attachhed"}</td>
                                        <td className="align-center font-size-text font-weight400" style={{ width: "10vw" }}>{items.description}</td>
                                    </tr>
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div >
    )
}

export default TransactionHistory